import React from 'react';
import { Carousel } from 'react-bootstrap';

const videoData = [
  {
    title: 'Health Insurance Unlocked',
    description: 'Secure Your Future Today! All about health insurance',
    url: 'https://www.youtube.com/embed/qP64WaVNJOw',
  },
  {
    title: 'Investment Tips for 2025',
    description: 'Make the right financial decisions this year.',
    url: 'https://www.youtube.com/embed/RoGPzJTKGGA',
  },
  {
    title: 'Understanding Mutual Funds',
    description: 'A beginner’s guide to mutual fund investing.',
    url: 'https://www.youtube.com/embed/0ZbbMo1EKMk',
  },
];

const YouTubeCarousel = () => {
  return (
    <div className="container my-5">
      <h2 className="text-center mb-4 text-success">VIDEOS FOR YOUR FINANCIAL WELL-BEING</h2>
      <Carousel>
        {videoData.map((video, index) => (
          <Carousel.Item key={index}>
            <div className="d-flex flex-column align-items-center">
              <div className="ratio ratio-16x9 w-100" style={{ maxWidth: '800px' }}>
                <iframe
                  src={video.url}
                  title={video.title}
                  allowFullScreen
                  frameBorder="0"
                ></iframe>
              </div>
              <div className="mt-3 text-center">
                <h5 className="fw-bold">{video.title.toUpperCase()}</h5>
                {/* <p>{video.description}</p> */}
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export default YouTubeCarousel;
